<template>
  <BreadCrumb PageTitle="Add Product" />
  <AddProduct />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import AddProduct from "../../template-components/Ecommerce/AddProduct/AddProduct.vue";

export default defineComponent({
  name: "AddProductPage",
  components: {
    BreadCrumb,
    AddProduct,
  },
});
</script>